import { SegmentOption } from 'src/app/components/gpd-segmented-switch/gpd-segmented-switch.component';

/** Shared by the project cost grid and the global cost overview (work item 4839). */
export const BEAUFTRAGT_FILTER_OPTIONS: SegmentOption[] = [
  { label: $localize`:@@all:All`, value: 0 },
  { label: $localize`:@@commissioned:Commissioned`, value: 1 },
  { label: $localize`:@@notCommissioned:Not commissioned`, value: 2 },
];

/** 0 = all, so the request field stays null and the API returns everything as before. */
export function beauftragtRequestValue(filter: number): boolean | null {
  if (filter === 1) return true;
  if (filter === 2) return false;
  return null;
}

/** Filename suffix for exports. Deliberately not derived from the translated label. */
export function beauftragtFileSlug(filter: number): string {
  if (filter === 1) return 'beauftragt';
  if (filter === 2) return 'nicht_beauftragt';
  return 'alle';
}
